<template>
  <div>
    <PageAllow controller="AccountLogs" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 -->
              <v-btn
                v-if="$permission.permissionAllow('AccountLogs', 'action')"
                small
                color="print"
                dark
                class="ms-1"
                @click.stop=""
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("AccountLogs.export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="keyword = $event"
                    :label="$t('AccountLogs.keyword')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <SearcherLogTypes v-model="options.types"/>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherAccountUsers
                    v-model="accountUsersSelected"
                    :label="$t('AccountLogs.Fields.account_user_name')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="logs"
          :options.sync="options"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          :page.sync="paging.page"
          :server-items-length="paging.count"
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
        <template v-slot:item.type_id="{ item }">
            <v-chip
                small
                label
                :color="item.type_id | logTypesColor"
                :text-color="item.type_id | logTypesTextColor"
                >{{ item.type_id | logTypesText }}
            </v-chip>
        </template>

          <template v-slot:item.data="{ item }">
            <v-btn
              @click.stop="
                Dialog = true;
                dataItem = item.request_detail;
              "
            >
              {{ $t("AccountLogs.data") }}
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <v-dialog v-model="Dialog" width="600px">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text v-model="dataItem">
          <JsonViewer 
            :value="this.jsonData"
            expanded
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherLogTypes from "@/components/plugins/SearcherLogTypes";
import SearcherAccountUsers from "@/components/plugins/SearcherAccountUsers"
import Logs from "@/api/logs";
import i18n from "@/i18n";
import JsonViewer from 'vue-json-viewer'


const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  keyword: "",
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("logs-options")
        ? sessionStorage.getItem("logs-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    keyword: "",
    logs: [],
    paging: {},
    Dialog: false,
    dataItem: null,
    jsonData: {},
    expanded:Boolean,
    types:[],
    accountUsersSelected: null,
  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.accountLogs"),
        disabled: false,
        href: "/settings/account-logs",
      },
      {
        text: i18n.t("SettingNav.manageAccountLogs"),
        disabled: true,
        href: "/settings/account-logs",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("AccountLogs.date"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("AccountLogs.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("AccountLogs.Fields.account_user_name"),
        align: "start",
        sortable: false,
        value: "account_user_name",
      },
      {
        text: i18n.t("AccountLogs.Fields.log_types"),
        align: "center",
        sortable: false,
        value: "type_id",
      },
      {
        text: i18n.t("AccountLogs.Fields.content"),
        align: "center",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("AccountLogs.Fields.url"),
        align: "start",
        sortable: false,
        value: "url",
      },
      {
        text: i18n.t("AccountLogs.Fields.data"),
        align: "center",
        sortable: false,
        value: "data",
      },
    ],
  },
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherLogTypes,
    SearcherAccountUsers,
    JsonViewer,
  },
  methods: {
    onSearch() {
      this.options = Object.assign({},this.options, {
        keyword: this.keyword,
      });
    },
    resetSearch() {
      this.accountUsersSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getLogsFromAPI() {
      this.loading = true;
      Logs.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.logs = response.data.logs;

            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
  },
  watch: {
    dataItem() {

        try {
            JSON.parse(this.dataItem)
            this.jsonData = JSON.parse(this.dataItem)
        } catch (error) {
            if(this.dataItem == null){
                this.jsonData = {}
            }else if(this.dataItem.length > 0 ){
                this.jsonData = this.dataItem
            }
        }
        
    },

    options: {
      deep: true,
      handler() {
        sessionStorage.setItem("logs-options", JSON.stringify(this.options));
        this.getLogsFromAPI();
      },
    },
    Dialog: {
      deep: true,
      handler() {
        if (!this.Dialog) {
          this.dataItem = null;
          this.jsonData = null;
        }
      }
    },
    accountUsersSelected: {
      handler() {
        this.options.account_user_ids = this.accountUsersSelected
            ? this.accountUsersSelected.map((e) => {
              return e.id;
            })
            : null;
      }
    },
    
  },
};
</script>

<style>
</style>